import { render, staticRenderFns } from "./Simulation.vue?vue&type=template&id=b7f2a878&scoped=true&"
import script from "./Simulation.vue?vue&type=script&lang=ts&"
export * from "./Simulation.vue?vue&type=script&lang=ts&"
import style0 from "./Simulation.vue?vue&type=style&index=0&id=b7f2a878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f2a878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
